import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
   ListItemButton,
  Link,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';



// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));
const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];
const indicatorCards = [
  { title: "Population totale", value: "12 332 788", color: primaryColor },
  { title: "Ménages ordinaires", value: "12 220 934", color: secondaryColor },
  { title: "Population urbaine", value: "3 077 593", color: primaryColor },
  { title: "Population rurale", value: "9 255 195", color: secondaryColor }
];

// Structure des données des ménages agricoles
const agriculturalData = {
  title: "Nombre de ménages agricoles par province selon le type d'activités agricoles pratiquées",
  columns: [
    "Agriculture végétale",
    "Sylvi-culture",
    "Elevage",
    "Pêche",
    "Myci-culture",
    "Apiculture traditionnelle",
    "Apiculture moderne",
    "Total ménages agricoles"
  ],
  provinces: [
    {
      name: "BURUNDI",
      values: ["2 296 588", "974 700", "1 585 091", "45 027", "11 820", "56 347", "6 503", "2 335 995"]
    },
    {
      name: "BUHUMUZA",
      values: ["413 547", "154 852", "283 135", "7 632", "1 724", "16 723", "1 108", "416 068"]
    },
    {
      name: "BUJUMBURA",
      values: ["437 105", "135 612", "274 263", "9 601", "2 648", "5 922", "1 394", "461 754"]
    },
    {
      name: "BURUNGA",
      values: ["407 406", "162 964", "270 969", "11 650", "2 189", "6 660", "826", "411 362"]
    },
    {
      name: "BUTANYERERA",
      values: ["547 465", "224 636", "384 179", "10 254", "2 584", "15 382", "1 483", "552 250"]
    },
    {
      name: "GITEGA",
      values: ["491 065", "296 636", "372 545", "5 890", "2 675", "11 660", "1 692", "494 561"]
    }
  ]
};

const AgriculturalHouseholdsPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Province\t" + agriculturalData.columns.join("\t") + "\n";
    
    agriculturalData.provinces.forEach(province => {
      tableContent += province.name + "\t" + province.values.join("\t") + "\n";
    });
    
    navigator.clipboard.writeText(`${agriculturalData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données sur les ménages agricoles du Burundi: ${agriculturalData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(agriculturalData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `menages-agricoles-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  // Calcul des indicateurs clés
  const parseNumber = (str) => parseInt(str.replace(/\s/g, ''), 10);

  const keyStats = {
    totalHouseholds: agriculturalData.provinces[0].values[7], // Total national
    
    mostCommonActivity: (() => {
      const nationalValues = agriculturalData.provinces[0].values.slice(0, -1);
      const maxIndex = nationalValues.indexOf(Math.max(...nationalValues.map(parseNumber)));
      return {
        name: agriculturalData.columns[maxIndex],
        value: nationalValues[maxIndex]
      };
    })(),
    
    provinceWithMostActivity: (activityIndex) => {
      return agriculturalData.provinces.slice(1).reduce((max, province) => 
        parseNumber(province.values[activityIndex]) > parseNumber(max.values[activityIndex]) ? province : max
      );
    },
    
    activityPercentage: (activityIndex) => {
      const nationalValue = parseNumber(agriculturalData.provinces[0].values[activityIndex]);
      const total = parseNumber(agriculturalData.provinces[0].values[7]);
      return ((nationalValue / total) * 100).toFixed(1);
    }
  };

  const filteredProvinces = agriculturalData.provinces.filter(province =>
    province.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

 
  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );


  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {agriculturalData.title}
                    </Typography>
                  </Box>
                     <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                           <Grid item xs={12} sm={6} md={6} ></Grid>
                              <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      size="small"
                      placeholder="Rechercher une province..."
                      variant="outlined"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search />
                          </InputAdornment>
                        ),
                      }}
                      sx={{ width: { xs: '100%', sm: '480px' } }}
                    />
                    </Grid>
                    </Grid>
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés sur l'Agriculture
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ménages Agricoles Totaux
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.totalHouseholds}
                              </Typography>
                              <Typography variant="caption">
                                Ménages recensés
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus d'agriculture végétale
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostCommonActivity.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostCommonActivity.value}
                                </Typography>
                                <Typography variant="h6" fontWeight="bold">
                                  ({keyStats.activityPercentage(0)}%)
                                </Typography>
                                </Stack>
                                 <Stack direction="row" spacing={1} alignItems="baseline">
                                 <Typography variant="caption">
                                  Au niveau national
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus d'élevage
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithMostActivity(2).name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithMostActivity(2).values[2]}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus de sylvi-culture
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.provinceWithMostActivity(1).name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.provinceWithMostActivity(1).values[1]}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des ménages agricoles">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province</TableCell>
                          {agriculturalData.columns.map((column, index) => (
                            <TableCell key={index} align="right">{column}</TableCell>
                          ))}
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredProvinces.map((province, index) => (
                          <ProvinceRow key={index} hover>
                            <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                              {province.name}
                            </TableCell>
                            {province.values.map((value, idx) => (
                              <TableCell key={idx} align="right">{value}</TableCell>
                            ))}
                          </ProvinceRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                    {/* 
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des ménages agricoles
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Les ménages agricoles sont définis comme des unités familiales pratiquant au moins une des activités suivantes:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      <ListItem>
                        <ListItemText 
                          primary="• Agriculture végétale: Culture de plantes alimentaires ou commerciales" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Sylvi-culture: Culture et exploitation des forêts" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Élevage: Production animale" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Pêche: Capture ou élevage de poissons" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Myci-culture: Culture de champignons" 
                        />
                      </ListItem>
                      <ListItem>
                        <ListItemText 
                          primary="• Apiculture: Production de miel" 
                        />
                      </ListItem>
                    </List>
                    <Typography variant="body2" mt={2}>
                      Ces données montrent que {keyStats.activityPercentage(0)}% des ménages agricoles pratiquent l'agriculture végétale,
                      faisant de cette activité la plus répandue au Burundi.
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Elevage (RGPHAE) 
                    réalisé en 2024. Un ménage peut pratiquer plusieurs activités agricoles simultanément, ce qui explique pourquoi 
                    les totaux par activité peuvent dépasser le nombre total de ménages agricoles. Les données reflètent 
                    les activités déclarées par les ménages lors du recensement.
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default AgriculturalHouseholdsPage;